import React, { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { ANNOUNCEMENTS } from "@/lib/store";

export default function AnnouncementBar() {
  const [index, setIndex] = useState(0);
  const reduce = useReducedMotion();

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % ANNOUNCEMENTS.length);
    }, 3800);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      className="bg-[#111C32] text-[#F7F4EF] h-9 flex items-center justify-center overflow-hidden"
      role="region"
      aria-label="Store announcements"
      data-testid="announcement-bar"
    >
      <div className="relative h-full w-full flex items-center justify-center">
        <AnimatePresence mode="wait">
          <motion.p
            key={index}
            className="text-[11px] md:text-xs uppercase tracking-[0.28em] text-[#D8BE87] absolute"
            initial={reduce ? false : { opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={reduce ? { opacity: 0 } : { opacity: 0, y: -8 }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            aria-live="polite"
          >
            {ANNOUNCEMENTS[index]}
          </motion.p>
        </AnimatePresence>
      </div>
    </div>
  );
}
